import { gql } from "@apollo/client";

//Query
export const CancelQuery = gql`
query cancellationData($reservationId: Int!, $userType: String!){
  cancelReservationData(reservationId: $reservationId, userType: $userType){
    id
    listId
    hostId
    guestId
    checkIn
    checkOut
    guests
    basePrice
    delivery
    listTitle
    hostServiceFee
    guestServiceFee
    total
    dayDifference
    currency
    confirmationCode
    reservationState
    discount
    cancellationPolicy
    isSpecialPriceAverage
    hostServiceFeeType
    hostServiceFeeValue
    startTime
    endTime
    dynamicListTitle
    promoCode
    promoCodeType
    promoCodeDescription
    promoDiscount
    optionsTotal
    reservationOptions {
      id
      code
      isFixed
      label
      labelKey
      description
      billingMode
      unitPrice
      quantity
      amount
      currency
      userInput
    }
    bookingSpecialPricing {
      id
      listId
      blockedDates
      isSpecialPrice      
    }
    cancellation {
          id
          policyName
          policyContent
          priorDays
          accommodationPriorCheckIn
          accommodationBeforeCheckIn
          accommodationDuringCheckIn
          guestFeePriorCheckIn
          guestFeeBeforeCheckIn
          guestFeeDuringCheckIn
          hostFeePriorCheckIn
          hostFeeBeforeCheckIn
          hostFeeDuringCheckIn
          isEnable
        }
    listData {
      id
      title
      settingsData{
        id
        settingsId
        listsettings {
            id
				    typeId
            itemName
            isEnable
            settingsType {
            typeName
           }
        }
      }
      reviewsCount
      reviewsStarRating
      transmission
      listingData {
        cancellation {
          id
          policyName
          policyContent
          priorDays
          accommodationPriorCheckIn
          accommodationBeforeCheckIn
          accommodationDuringCheckIn
          guestFeePriorCheckIn
          guestFeeBeforeCheckIn
          guestFeeDuringCheckIn
          hostFeePriorCheckIn
          hostFeeBeforeCheckIn
          hostFeeDuringCheckIn
          isEnable
        }
      }
      coverPhoto
      listPhotos{
         id,
         listId,
         name,
         type,
      }
    }
    messageData {
      id
    }
    messageThreadId {
     id
    }
    hostData {
      profileId
      firstName
      picture
      createdAt
      userData {
        email
      }
    }
    guestData {
      profileId
      firstName
      picture
      createdAt
      userData {
        email
      }
    }
  }
}`;